import React, { Component } from "react";
import AgGridTable from "../../../components/common/agGridTable";
import ReadAxios from "../../../components/axiosComponent/read";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import { isEmpty } from "lodash";
import {HEADERS,TITLES} from './yardConstants'
import cogoToast from "cogo-toast";
import { TOAST_MESSAGES } from "../../../utils/toastMsgConstant";
import { FEATURES } from "../../../utils/constant";

class Yard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowData: [],
      loadingData: true,
    };
  }

  componentDidMount() {
    ReadAxios({ completeURL: `${process.env.REACT_APP_MASTER_API}/yard` })
      .then((dataArray) => {
        let data = isEmpty(dataArray) ? [] : dataArray.data?.resultSet
        this.setState({
          rowData: data,
          loadingData: false,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loadingData: false, rowData: [] });
      });
  }

  onCellClicked = (rowData) => {
      typeof rowData.value != 'undefined' && this.onRowEdit(rowData.data);
  }

  onRowEdit = (rowData) => {
    if(rowData.customerNumber === 0){
      cogoToast.error(TOAST_MESSAGES.CANNOT_EDIT_DEFAULT_RECORDS);
      return false
    }
    this.props.history.push("/edit-yard", {
      ...rowData,
      title: "edit_title",
    });
  };

  onRowDelete = (alert) => {
    if (alert.type === "success") this.props.successAlert(alert);
    else this.props.errorAlert(alert);
    this.props.history.push("/yard");
    this.props.history.go();
  };

  render() {
    const { rowData } = this.state;
    const { t } = this.props;
    const Columns = [
      {
        headerName: HEADERS.yard_code||"Yard Code",
        field: "yardCode",
        sortable: true,
        filter: true,
      },
      {
        headerName:HEADERS.yard||"Yard",
        field: "yardName",
        sortable: true,
        filter: true,
      },
      {
        headerName:HEADERS.latitude||"Checkpoint Latitude",
        field: "checkPointLattitude",
        sortable: true,
        filter: true,
      },
      {
        headerName:HEADERS.longitude||"Checkpoint Longitude",
        field: "checkPointLongitude",
        sortable: true,
        filter: true,
      },
      {
        headerName:HEADERS.radius||"Checkpoint Radius",
        field: "checkPointRadius",
        sortable: true,
        filter: true,
      },
      {
        headerName:HEADERS.city||"City",
        field: "cityName",
        sortable: true,
        filter: true,
      },
      {
        headerName: HEADERS.created_by||"Created By",
        field: "createdByName",
        sortable: true,
        filter: true,
      },
      {
        headerName: HEADERS.created_on||"Created On",
        field: "createdOn",
        sortable: true,
        filter: true,
      },
      {
        headerName: HEADERS.modified_by||"Modified By",
        field: "updatedByName",
        sortable: true,
        filter: true,
      },
      {
        headerName:HEADERS.modified_on||"Modified On",
        field: "updatedOn",
        sortable: true,
        filter: true,
      },
      {
        headerName:HEADERS.actions||"Edit/Delete",
        field: "edit",
        cellRenderer: "actionRenderer",
        suppressToolPanel: true,
        pinned: "right",
      },
    ];
    return (
      <React.Fragment>
        <AgGridTable
          isLoading={this.state.loadingData}
          columnDefs={Columns}
          rowData={rowData}
          titleBarTitle={TITLES.main_title||"Yard"}
          titleBarLink={"/add-yard"}
          baseURL={"yardMaster"}
          completeURL={`${process.env.REACT_APP_MASTER_API}/yard`}
          pathName={"yardMaster"}
          keyIndex={"yardId"}
          onEdit={this.onRowEdit}
          cellDoubleClicked={this.onCellClicked}
          onDelete={this.onRowDelete}
          hideRowDelete={false}
          hideFilter={true}
          exportHidden={FEATURES.mastersExportDisabled()}
          suppressExcelExport={FEATURES.mastersExportDisabled()}
          suppressCsvExport={FEATURES.mastersExportDisabled()}
        />
      </React.Fragment>
    );
  }
}
const mapStateToProps = ({ permissions }) => {
  return {
    permissions,
  }
};
const mapDispatchToProps = (dispatch) => {
  return {
    successAlert: (alert) => dispatch(successAlertDispatcher(alert)),
    errorAlert: (alert) => dispatch(errorAlertDispatcher(alert)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(translate("yard")(Yard));
